import React, { useState, useEffect } from "react";

import { Tabs } from "antd";
import AdminBookingScreen from "./AdminBookingScreen";
import AdminHotelScreen from "./AdminHotelScreen";
import AdminUserScreen from "./HotelAdminUserScreen";
import AdminAddRoomScreen from "./HotelAdminAddRoomScreen";
// import AdminUpdateRoomScreen from "./AdminUpdateRoomScreen";
const { TabPane } = Tabs;
function callback(key) {
  console.log(key);
}
function AdminScreen() {
  const user = JSON.parse(localStorage.getItem("currentUser"));

  useEffect(() => {
    if (!user || user.isAdmin == false) {
      window.location.href = "/home";
    }
  }, []);

  return (
    <div className="ml-3 mt-3 mr-3 bs">
      <h1 className="text-center">Admin Panel</h1>
      <Tabs defaultActiveKey="1" onChange={callback}>
        {/* <TabPane tab="Bookings" key="1" >
          <AdminBookingScreen></AdminBookingScreen>
        </TabPane> */}
        <TabPane tab="Hotels" key="2">
          <AdminHotelScreen></AdminHotelScreen>
        </TabPane>
        <TabPane tab="Add Hotel" key="3">
          <AdminAddRoomScreen></AdminAddRoomScreen>
        </TabPane>
        <TabPane tab="Users" key="4">
          <AdminUserScreen></AdminUserScreen>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default AdminScreen;
